import { useQuery } from "react-query";
import { loggedInApiCall } from "src/api/axiosClient/userApi";
import { isQueryReady } from "src/api/axiosClient/utils";
import { zodParseWithDetailedLog } from "src/api/apiErrorLogs";
import { z } from "zod";

export const getSsqVersionAssignmentKey = "getSsqVersionAssignment" as const;

const SsqVersionAssignmentSchema = z.object({
    ssqId: z.number(),
    ssqVersionId: z.number(),
});

type SsqVersionAssignment = z.infer<typeof SsqVersionAssignmentSchema>;

export const useGetSsqVersionAssignment = (ssqId: number | null | undefined, campaignId: number | undefined) => {
    const isEnabled = ssqId != null && campaignId !== undefined;

    const query = useQuery({
        enabled: isEnabled,
        queryKey: [getSsqVersionAssignmentKey, campaignId, ssqId],
        queryFn: async () => {
            const response = await loggedInApiCall.get(
                `/api/ssq-version-assignments/campaign/${campaignId}/ssq/${ssqId}`,
            );
            return response.data;
        },
        select: (data): SsqVersionAssignment => {
            return zodParseWithDetailedLog(data, SsqVersionAssignmentSchema, {
                operation: "GET",
                endpoint: `/api/ssq-version-assignments/campaign/${campaignId}/ssq/${ssqId}`,
            });
        },
    });

    const isReady = isQueryReady(query, isEnabled);

    return {
        ssqVersionAssignment: query.data,
        isReady,
        ...query,
    };
};
